import axios from "axios";
import store from "./store.js";
import router from "./router/index.js";

const $axios = axios.create({
  baseURL: "https://api.websms.co.id/api",
  headers: {
    "Content-Type": "application/json",
  },
});

$axios.interceptors.request.use(
  function(config) {
    const token = store.state.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

$axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status == 401) {
      store.commit("SET_TOKEN", null, { root: true });
      localStorage.removeItem("token");
      router.push({ name: "Login" });
    }
    return Promise.reject(error);
  }
);

export default $axios;
